
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TurbineSignalsGQL, TurbineSignalDataSeriesGQL } from '../../graphql';
import { map, distinctUntilChanged, switchMap, filter } from 'rxjs/operators';

@Injectable()
export class ConditionComponentGraphService {

  constructor(
    private turbineSignalsGQL: TurbineSignalsGQL,
    private turbineSignalDataSeriesGQL: TurbineSignalDataSeriesGQL
  ) { }

  public getTurbineSignalsD(turbineSerial: number): Observable<any> {
    return this.turbineSignalsGQL.watch({ 
      variables: { serialNav: Number(turbineSerial) } }).valueChanges.pipe(
        filter(result => !result.loading && !!result.data)
      );
  }

  public getTurbineSignalsData(turbineSerialObservable: Observable<number>): Observable<any> {
    return turbineSerialObservable.pipe(
      distinctUntilChanged(),
      switchMap((turbine: number) =>
        this.turbineSignalsGQL.watch({
          variables: { serialNav: turbine }
        }).valueChanges.pipe(
          filter(result => !result.loading && !!result.data),
          map(result => result.data.turbines[0])
        )
      )
    );
  }

  public getTurbineSignalsSeriesData(serialNav: number, signal: string, hours: number): Observable<any> {
    return this.turbineSignalDataSeriesGQL.subscribe({
      variables: {
      serialNav,
      signal,
      hours}
    }).pipe(
      map(result => {
        return this.parseResponse({ data: result.data.turbines[0].parkSubType.turbines, hours }, { data: result.data.turbines[0].reference.turbineSubTypes[0] });
      })
    )
  }

  private parseResponse(turbine: { data: any, hours: number }, subtype: { data: any }) {
    return Object.assign({
      turbines: this.getTurbines(turbine.data),
      serials: this.getSerialNav(turbine.data),
      temperatures: this.getTemperatures(turbine.data),
      timestamps: this.getTimestamps(turbine.data),
      averageTemperatures: subtype.data.componentConditionDataSeries.data,
      hoursRange: turbine.hours
    });
  }

  private getTurbines(data) {
    return data.map(d => d.code);
  }

  private getSerialNav(data) {
    return data.map(d => d.serialNav);
  }

  private getTemperatures(data) {
    return data.map(d => d.componentConditionDataSeries.data);
  }

  private getTimestamps(data) {
    const startingTS = data[0].componentConditionDataSeries.startingTS;
    const lastTS = data[0].componentConditionDataSeries.lastTS;
    const intervalTS = data[0].componentConditionDataSeries.intervalTS;
    const timestamps = [];
    if (startingTS !== lastTS) {
      for (let i = startingTS; i <= lastTS; i += intervalTS) {
        timestamps.push(i);
      }
    }
    return timestamps;
  }

}
